export const MINUTES_IN_HOUR = 60;
